import init from '@gleerups/error-reporter';

export function initErrorReporter() {
  init({
    application: 'auth-ui',
    commitSha: import.meta.env.VITE_SHORT_SHA || 'unknown',
    commitBranch: import.meta.env.VITE_REF_NAME || 'unknown',
  });
}
